"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getListOfGigsUnderSupervisor = getListOfGigsUnderSupervisor;
const baseUrls_1 = require("./baseUrls");
const fetchWrapper_1 = require("./fetchWrapper");
async function getListOfGigsUnderSupervisor(authHeader) {
    const headers = {
        Authorization: authHeader,
    };
    return (0, fetchWrapper_1.fetchWrapper)(`${baseUrls_1.ApiBaseUrl}/getListOfGigsUnderSupervisor`, {
        method: "GET",
        headers: headers,
    });
}
